import { render, staticRenderFns } from "./TransportLayout.vue?vue&type=template&id=781ecf8e&scoped=true&"
import script from "./TransportLayout.vue?vue&type=script&lang=js&"
export * from "./TransportLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ecf8e",
  null
  
)

export default component.exports